/**
 * ns.wow Cookies
 * Facade class for public accessible plugin functionality.
 */

import 'web-animations-js';


class Plugin {

	RELOAD_STATISTICS = false;
	RELOAD_MARKETING = false;

	initSimple() {
		const bannerLegacy = document.querySelector('.js-nhscookie-note');
		const banner = document.querySelector('#nswow-cookie-banner');

		// show legacy banner via old template hook
		if(bannerLegacy){
			const acceptLegacy = document.querySelector('.js-nhscookie-note-button');
			if (!this.getCookie('nswowCookieNotice')) {
				bannerLegacy.style.display = 'block';
			}
			acceptLegacy.addEventListener('click', (event) => {
				bannerLegacy.style.display = 'none';
				event.preventDefault();
				this.setCookie('nswowCookieNotice', 'true', 365);
			});

		}

		// show banner via this plugin template
		if(banner){
			const accept = document.querySelector('#nswow-cookie-accept');
			if (!this.getCookie('nswowCookieNotice')) {
				banner.classList.add('is-active');
			}
			accept.addEventListener('click', (event) => {
				banner.classList.remove('is-active');
				event.preventDefault();
				this.setCookie('nswowCookieNotice', 'true', 365);
			});
		}
	}

	initAdvanced() {

		const banner = document.querySelector('#nswow-cookie-banner');
		const togBanner = document.querySelector('#nswow-cookie-banner-tog');
		const accept = document.querySelector('#nswow-cookie-accept');
		const acceptGroupStatistics = document.querySelector('#acceptGroupStatistics');
		const acceptGroupMarketing = document.querySelector('#acceptGroupMarketing');
		const save = document.querySelector('#nswow-cookie-save');
		const moreinfo = document.querySelectorAll('.moreInfoTog');
		const iframeAccept = document.querySelectorAll('.nhsCookieAcceptMarketingCookie');

		iframeAccept.forEach(item => {
			item.addEventListener('click', (event) => {
				event.preventDefault();
				this.setCookie('nswowCookieMarketing', true, 365);
				location.reload();
			});
		})

		if (!this.getCookie('nswowCookieNotice')) {
			banner.classList.add('is-active');
		}

		togBanner.addEventListener('click', (event) => {
			banner.classList.add('is-active');
			event.preventDefault();
			this.setCookie('nswowCookieNotice', 'true', 365);
		});

		accept.addEventListener('click', (event) => {
			banner.classList.remove('is-active');
			event.preventDefault();
			this.setCookie('nswowCookieMarketing', true, 365);
			this.setCookie('nswowCookieStatistics', true, 365);
			this.setCookie('nswowCookieNotice', 'true', 365);
			this.addScriptGroup('nswowCookieMarketing');
			this.addScriptGroup('nswowCookieStatistics');
			this.addDataLayerScript('nswowCookieStatisticsDataLayer', 'nswowCookieStatistics');
			this.addDataLayerScript('nswowCookieMarketingDataLayer', 'nswowCookieMarketing');
			acceptGroupStatistics.checked = true;
			acceptGroupMarketing.checked = true;
		});

		acceptGroupStatistics.addEventListener('change', (event) => {
			if (event.currentTarget.checked) {
				this.RELOAD_STATISTICS = false;
			} else {
				this.RELOAD_STATISTICS = true;
			}
		})

		acceptGroupMarketing.addEventListener('change', (event) => {
			if (event.currentTarget.checked) {
				this.RELOAD_MARKETING = false;
			} else {
				this.RELOAD_MARKETING = true;
			}
		})

		save.addEventListener('click', (event) => {
			banner.classList.remove('is-active');
			this.setCookie('nswowCookieNotice', 'true', 365);
			event.preventDefault();
      // Statistics scripts
			if (acceptGroupStatistics.checked) {
				this.setCookie('nswowCookieStatistics', true, 365);
				this.addScriptGroup('nswowCookieStatistics');
				this.addDataLayerScript('nswowCookieStatisticsDataLayer', 'nswowCookieStatistics');
			} else {
				this.removeCookie('nswowCookieStatistics');
				this.removeCookieGroup('nswowCookieStatistics');
			}
      // Marketing scripts
			if (acceptGroupMarketing.checked) {
				this.setCookie('nswowCookieMarketing', true, 365);
				this.addScriptGroup('nswowCookieMarketing');
				this.addDataLayerScript('nswowCookieMarketingDataLayer', 'nswowCookieMarketing');
			} else {
				this.removeCookie('nswowCookieMarketing');
				this.removeCookieGroup('nswowCookieMarketing');
			}
			// Reload if necessary
			if (this.RELOAD_STATISTICS == true || this.RELOAD_MARKETING == true) {
				location.reload();
			}
		});

		moreinfo.forEach(item => {
			item.addEventListener('click', (event) => {
				event.preventDefault();
				let parentElement = item.closest('._group');
				let parentElementIsOpen = parentElement.classList.contains('is-active');
				banner.querySelectorAll('._group').forEach(item => {
					item.classList.remove('is-active');
				});
				if (!parentElementIsOpen) {
					parentElement.classList.add('is-active');
				}
			});
		})

	}

	getCookie(cookieName) {
		let cookie = {};
		document.cookie.split(';').forEach(function (el) {
			let [key, value] = el.split('=');
			cookie[key.trim()] = value;
		})
		return cookie[cookieName];
	}

	setCookie(name, value, days) {
		let path = NSContext.plugins.cookies.scope;
		let expires = ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=' + path;
	}

	removeCookie(name) {
		this.setCookie(name, '', null);
	}

	removeCookieGroup(group) {
		let cookiesItems = group == 'nswowCookieMarketing' ? NSContext.plugins.cookies.config.groups.nswowCookieMarketing : NSContext.plugins.cookies.config.groups.nswowCookieStatistics;
		cookiesItems.forEach(async (item) => {
			let name = item['name'];
			let expires = ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
			document.cookie = name + '=' + '' + expires + '; path=/';
		});
	}

	addScriptGroup(scriptId) {

		if (navigator.doNotTrack === "1" || navigator.doNotTrack === "yes" || window.doNotTrack === "1") {
			// don't load anything
			return;
		}

		let scriptsItems = scriptId == 'nswowCookieMarketing' ? NSContext.plugins.cookies.config.groups.nswowCookieMarketing : NSContext.plugins.cookies.config.groups.nswowCookieStatistics;

		scriptsItems.forEach(async (item) => {

			let assistant = item['assistant'];
			let over_gtm = item['over_gtm'];
			let id = item['id'];
			let head_end = item['head_end'];
			let body_start = item['body_start'];
			let body_end = item['body_end'];

			if (over_gtm == false) {

				if (assistant == 'analytics') {
					let analyticScriptId = document.getElementById('nswow-cookie-assistant-analytics-id');
					if (analyticScriptId !== null) {
						analyticScriptId.remove();
					}
					let analyticScriptIdNew = document.createElement("script");
					analyticScriptIdNew.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
					analyticScriptIdNew.async = true;
					analyticScriptIdNew.id = 'nswow-cookie-assistant-analytics-id';
					document.head.append(analyticScriptIdNew);

					let analyticScriptConfig = document.getElementById('nswow-cookie-assistant-analytics-config');
					if (analyticScriptConfig !== null) {
						analyticScriptConfig.remove();
					}
					let analyticScriptConfigNew = document.createElement("script");
					analyticScriptConfigNew.id = 'nswow-cookie-assistant-analytics-config';
					analyticScriptConfigNew.innerHTML = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date());gtag('config', '" + id + "');";
					document.head.append(analyticScriptConfigNew);
				}

				if (assistant == 'matomo') {
					let matomoScriptConfig = document.getElementById('nswow-cookie-assistant-matomo-config');
					if (matomoScriptConfig !== null) {
						matomoScriptConfig.remove();
					}
					let matomoScriptConfigNew = document.createElement("script");
					matomoScriptConfigNew.id = 'nswow-cookie-assistant-matomo-config';
					matomoScriptConfigNew.innerHTML = "var _paq = window._paq = window._paq || [];_paq.push(['trackPageView']);_paq.push(['enableLinkTracking']);(function() {var u=\""+item['url']+"\";_paq.push(['setTrackerUrl', u+'matomo.php']);_paq.push(['setSiteId',"+id+"]);var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);})();";
					document.head.append(matomoScriptConfigNew);
				}

				if (assistant != 'analytics' && assistant != 'matomo' ){
					if (head_end) {
						this.createCleanScript('scriptHeadStatistics', 'head_end', head_end);
						this.createCleanScript('scriptHeadMarketing', 'head_end', head_end);
					}
					if (body_start) {
						this.createCleanScript('scriptBodyStatistics', 'body_start', body_start);
						this.createCleanScript('scriptBodyMarketing', 'body_start', body_start);
					}
					if (body_end) {
						this.createCleanScript('scriptBodyEndStatistics', 'body_end', body_end);
						this.createCleanScript('scriptBodyEndMarketing', 'body_end', body_end);
					}
				}

			}

		});

	}

	createCleanScript(scriptID, positions, newCode) {

		let scriptElement = document.getElementById(scriptID);
		let innerHtml = '';
		if (scriptElement !== null) {
			innerHtml = scriptElement.innerHTML;
			scriptElement.remove();
		}
		let script = document.createElement("script");
		script.id = scriptID;
		let cleanInnerHtml = innerHtml.replace(/[^a-z0-9]/gi, '');
		let cleanNewCode = newCode.replace(/[^a-z0-9]/gi, '');

		if (cleanInnerHtml.search(cleanNewCode) === -1) {
			script.innerHTML = innerHtml + newCode;
		} else {
			script.innerHTML = innerHtml;
		}
		if (positions === 'head_end') {
			document.head.append(script);
		}
		if (positions === 'body_start') {
			document.body.prepend(script);
		}
		if (positions === 'body_end') {
			document.body.append(script);
		}

	}

	addDataLayerScript(scriptID, eventName) {

		// Respect "do not track" browser settings

		if (navigator.doNotTrack === "1" || navigator.doNotTrack === "yes" || window.doNotTrack === "1") {
			// don't load anything
			return;
		}

		let scriptElement = document.getElementById(scriptID);
		if (scriptElement !== null) {
			scriptElement.remove();
		}
		let script = document.createElement("script");
		script.id = scriptID;
		script.innerHTML = "window.dataLayer = window.dataLayer || [];dataLayer.push({'event': '" + eventName + "'});window._mtm = window._mtm || [];_mtm.push({'event': '"+ eventName + "'});"
		document.head.append(script);

	}

}

export default new Plugin();
